import axios from "axios";
import {
  SESSION_ATTEMPT,
  SESSION_SUCCESSFULL,
  SESSION_FAILED,
  /////////////
  SESSION_SUCCESS_MESSAGE,
  SESSION_FAILED_MESSAGE,
  SESSION_FAILED_UPDATE,
  //////////
  LOGOUT,
  DESTROY_SESSION,
  //////////////
  POPUP
} from "../types/sessionType";
import { config } from "../../config";
import { unregisterDeviceToken } from "../../utils/firebaseMessaging";


const url_api = config.api.godiway;
export function loading() {
  return {
    type: SESSION_ATTEMPT,
  };
}
export function success(item) {
  return {
    type: SESSION_SUCCESSFULL,
    item: item,
  };
}
export function failed(error) {
  return {
    type: SESSION_FAILED,
    error: error,
  };
}
///////////////
export function successMessage(success) {
  return {
    type: SESSION_SUCCESS_MESSAGE,
    success: success,
  };
}
export function failedMessage(error) {
  return {
    type: SESSION_FAILED_MESSAGE,
    error: error,
  };
}
export function failedUpdate(error) {
  return {
    type: SESSION_FAILED_UPDATE,
    error: error
  }
}
///////////////////////////
export function logout() {
  return {
    type: LOGOUT,
  };
}
/////////////////
export function popup() {
  return {
    type: POPUP,
  };
}
////////////////////////////////////

export const logoutRequest = (data: Object) => async (dispatch, getState) => {
  const auth = getState().session?.auth;

  if (auth?.id && auth?.access_token) {
    await unregisterDeviceToken(auth.id, auth.access_token);
  }

  dispatch(logout());
  //dispatch({ type: DESTROY_SESSION });
  //window.location.reload();
  //////////
};
export const setPopup = (data: Object) => async (dispatch) => {
  dispatch(popup());
};

export const loginRequest = (data: Object) => async (dispatch) => {
  dispatch(loading());
  await axios({
    method: "post",
    url: url_api + "auth/login",
    data: { username: data.email, password: data.password },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${data.token}`,
    },
    validateStatus: (status) => status >= 200 && status < 600,
  })
    .then(function (response) {
      if (response.data.status === "Success")
        dispatch(success(response.data.body));
      else dispatch(failed(response.data.body || "try_later"));
    })
    .catch(function (error) {
      console.log("Error", error.message);
      const apiError = error.response && error.response.data && error.response.data.body;
      dispatch(failed(apiError || "try_later"));
    });
  return;
};

export const sendLoginCodeRequest = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios({
      method: "post",
      url: url_api + "auth/login/code/send",
      data: { email: data.email },
      headers: { "Content-Type": "application/json" },
      validateStatus: (status) => status >= 200 && status < 600,
    });

    if (response.data.status === "Success") {
      dispatch(successMessage("login_code_sent"));
      return { success: true, data: response.data.body };
    }

    const error = response.data.body || "try_later";
    dispatch(failed(error));
    return { success: false, error };
  } catch (error) {
    const apiError =
      error.response && error.response.data && error.response.data.body;
    dispatch(failed(apiError || "try_later"));
    return { success: false, error: apiError || "try_later" };
  }
};

export const loginWithCodeRequest = (data: Object) => async (dispatch) => {
  dispatch(loading());
  await axios({
    method: "post",
    url: url_api + "auth/login/code",
    data: { email: data.email, code: data.code },
    headers: { "Content-Type": "application/json" },
    validateStatus: (status) => status >= 200 && status < 600,
  })
    .then(function (response) {
      if (response.data.status === "Success")
        dispatch(success(response.data.body));
      else dispatch(failed(response.data.body || "try_later"));
    })
    .catch(function (error) {
      const apiError =
        error.response && error.response.data && error.response.data.body;
      dispatch(failed(apiError || "try_later"));
    });
  return;
};

export const loginSocialRequest = (data: Object) => async (dispatch) => {
  dispatch(loading());
  await axios({
    method: "post",
    url: url_api + "auth/social",
    data: data.params,
    headers: { Authorization: `Bearer ${data.token}` },
  })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error.message);
      if (error.response) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
    });
  return;
};





export const loginTokenRequest = (data: Object) => async (dispatch) => {
  //dispatch(loginLoading());
  await axios({
    method: "post",
    url: url_api + "auth/token",
    data: { id: data.user_id, email: data.email },
    // headers: { Authorization: `Bearer ${data.token}` },
  })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error.message);
      if (error.response) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
    });
  return;
};

export const adminLoginRequest = (token) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: url_api + "auth/admin-login",
      data: { token },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
      return { ok: true };
    }

    const error = response.data.body || "try_later";
    dispatch(failed(error));
    return { ok: false, error };
  } catch (error) {
    console.log(error.message);
    dispatch(failed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const sendFeedBack = (data: Object) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: url_api + "auth/feedback",
      data: { comment: data.comment },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(successMessage(response.data.body));
      return { ok: true };
    }

    const error = response.data.body || "try_later";
    dispatch(failedMessage(error));
    return { ok: false, error };
  } catch (error) {
    console.log(error.message);
    dispatch(failedMessage("try_later"));
    return { ok: false, error: "try_later" };
  }
};

////////////////////////////////////////////////////////

export const newItem = (data: Object) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.post(url_api + "auth/register", data.params, {
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.data.status === "Success") {
      const body = response.data.body;

      if (body === "register_pending" || !body?.token) {
        dispatch(logout());
        dispatch(successMessage("register_pending"));
        return { ok: true, pendingActivation: true };
      }

      dispatch(success(body));
      return { ok: true };
    }

    dispatch(failedMessage(response.data.body));
    return { ok: false, error: response.data.body };
  } catch (error) {
    const message = error.response?.data?.body || "try_later";
    dispatch(failedMessage(message));
    return { ok: false, error: message };
  }
};

export const activateAccount = (token) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.put(url_api + "auth/activate", { token });

    if (response.data.status === "Success") {
      dispatch(successMessage(response.data.body));
      return { ok: true };
    }

    dispatch(failedMessage(response.data.body));
    return { ok: false, error: response.data.body };
  } catch (error) {
    const message = error.response?.data?.body || "try_later";
    dispatch(failedMessage(message));
    return { ok: false, error: message };
  }
};

export const loadItem = (data: Object) => async (dispatch) => {
  dispatch(loading());
  //console.log(data.user_id);
  await axios
    .get(url_api + "auth", {
      params: {
        id: data.user_id,
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      // console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};

export const loadItemAll = (data: Object) => async (dispatch) => {
  dispatch(loading());
  //console.log(data.user_id);
  await axios
    .get(url_api + "auth/all", {
      params: {
        id: data.user_id,
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      // console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};

export const updateItem = (data: Object) => async (dispatch) => {
  await axios({
    method: "post",
    url: url_api + "auth",
    data: data.params,
    headers: { Authorization: `Bearer ${data.token}` },
  })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failedMessage(response.data.body));
      } else {
        dispatch(failedMessage("try_later"));
      }
    })
    .catch(function (error) {
      console.log("Error", error.message);
      if (error.response) {
        dispatch(failedMessage("try_later"));
      } else {
        dispatch(failedMessage("try_later"));
      }
    });
};

export const updatefield = (data: Object) => async (dispatch) => {
  // dispatch(Loading());
  // console.log(data);
  await axios
    .put(url_api + "auth", data.params, { headers: { Authorization: `Bearer ${data.token}` }, })
    .then(function (response) {
      // console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failedMessage(response.data.body));
      } else {
        dispatch(failedMessage("try_later"));
      }
    })
    .catch(function (error) {
      console.log("Error", error.message);
      if (error.response) {
        dispatch(failedMessage("try_later"));
      } else {
        dispatch(failedMessage("try_later"));
      }
    });
};

export const syncSessionVerified = (verified) => (dispatch, getState) => {
  const auth = getState().session.auth;

  if (!auth || !auth.id) {
    return;
  }

  if (Boolean(auth.verified) === Boolean(verified)) {
    return;
  }

  dispatch(success({ ...auth, verified: Boolean(verified) }));
};

export const loadAvatar = (data: Object) => async (dispatch) => {
  try {
    //loadingUpImage(0);
    var request = new XMLHttpRequest();
    request.open("post", url_api + "auth/avatar");
    request.setRequestHeader('Authorization', `Bearer ${data.token}`);
    // request.setRequestHeader(
    //   'Content-Type', 'multipart/form-data'
    // );
    request.onload = () => {
      if (request.status < 300) {
        const response = JSON.parse(request.response);
        if (response.status === "Success")
          dispatch(success(response.body));
        else {
          dispatch(failedMessage("try_later"));
        }
        //console.log(data);
      } else {
        console.error(request.response);
        dispatch(failedMessage("try_later"));
      }
    };
    await request.send(data.params);
    if (request.upload) {
      request.upload.onprogress = ({ total, loaded }) => {
        const uploadProgess = loaded / total;
        console.log(uploadProgess);
        //dispatch(loadingUpImage(uploadProgess));
      };
    }
  } catch (error) {
    console.error(error);
    dispatch(failedMessage("try_later"));
  }
};

export const forgetPassword = (data: Object) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.get(url_api + "auth/forget", {
      params: {
        email: data.email,
      },
    });

    if (response.data.status === "Success") {
      dispatch(successMessage(response.data.body));
      return { ok: true };
    }

    dispatch(failedMessage(response.data.body));
    return { ok: false, error: response.data.body };
  } catch (error) {
    const message = error.response?.data?.body || "try_later";
    dispatch(failedMessage(message));
    return { ok: false, error: message };
  }
};

export const changePassword = (data: Object) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.put(
      url_api + "auth/reset",
      {
        password: data.password,
        token: data.token,
      },
      {
        headers: { Authorization: `Bearer ${data.token}` },
        validateStatus: (status) => status >= 200 && status < 600,
      }
    );

    if (response.data.status === "Success") {
      dispatch(successMessage(response.data.body));
      return { ok: true };
    }

    dispatch(failedMessage(response.data.body));
    return { ok: false, error: response.data.body };
  } catch (error) {
    const message = error.response?.data?.body || "try_later";
    dispatch(failedMessage(message));
    return { ok: false, error: message };
  }
};

export const resetPassword = (data: Object) => async (dispatch) => {
  //dispatch(Loading());
  await axios
    .put(url_api + "auth/pwd", {
      currentPassword: data.password_old,
      newPassword: data.password_new,
      id: data.user_id,
    }, { headers: { authorization: `Bearer ${data.token}` }, })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(successMessage(response.data.body));
        else dispatch(failedMessage(response.data.body));
      } else {
        dispatch(failedMessage("try_later"));
      }
    })
    .catch(function (error) {
      if (error.response) {
        dispatch(failedMessage("try_later"));
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
        dispatch(failedMessage("try_later"));
      }
    });
};





export const checkPassword = (data: Object) => async (dispatch) => {
  //dispatch(Loading());
  await axios
    .post(url_api + "auth/check", {
      id: data.user_id,
      pwd: data.password,
    }, { headers: { Authorization: `Bearer ${data.token}` }, })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(successMessage(response.data.body));
        else dispatch(failedUpdate(response.data.body));
      } else {
        dispatch(failedUpdate("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.response) {
        dispatch(failedUpdate("try_later"));
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
        dispatch(failedUpdate("try_later"));
      }
    });
};

export const deleteAccount = (data: Object) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.post(
      `${url_api}auth/delete`,
      {
        id: data.user_id,
        pwd: data.password,
      },
      {
        headers: { Authorization: `Bearer ${data.token}` },
        validateStatus: (status) => status >= 200 && status < 600,
      }
    );

    if (response.data.status === "Success") {
      if (data.user_id) {
        try {
          localStorage.removeItem(`godiway_2fa_${data.user_id}`);
        } catch (error) {
          // ignore storage errors
        }
      }
      if (data.user_id && data.token) {
        await unregisterDeviceToken(data.user_id, data.token);
      }
      dispatch(logout());
      return { success: true };
    }

    dispatch(failedUpdate(response.data.body || "try_later"));
    return { success: false, error: response.data.body || "try_later" };
  } catch (error) {
    dispatch(failedUpdate("try_later"));
    return { success: false, error: "try_later" };
  }
};

